<script>
    import Requirement from "../ui/Requirement.svelte";

    export let minDuration;
    export let duration;
    export let blocked;
</script>

<div>
    {#if minDuration}
        <Requirement condition={duration>=minDuration}>
            Zeitraum muss mindestens {minDuration} Tage lang sein
        </Requirement>
    {/if}
    <Requirement condition={!blocked}>
        Zeitraum darf keine belegten Tage enthalten
    </Requirement>
</div>

<style>
    div {
        margin: 1rem 0 0;
    }
</style>